export const LIKE_UPDATE = 'LIKE_UPDATE'
export const LIKE_WAS_UPDATED = 'LIKE_WAS_UPDATED'
export const LIKE_RESET = 'LIKE_RESET'
export const LIKE_ERROR = 'LIKE_ERROR'
